// extracted by mini-css-extract-plugin
export default {"scrollTopBtn":"ScrollToTopButton_scrollTopBtn__CkA6a","show":"ScrollToTopButton_show__BrTRR","scrollTopIcon":"ScrollToTopButton_scrollTopIcon__9L2NE"};